// Workflow Types
export enum WORKFLOW_TYPES {
	INTAKE = 'intake',
	SMS = 'sms',
	TRANSFER = 'transfer',
}

// Agent Workflow Field Names
export enum AGENT_WORKFLOW_FIELDS {
	INTAKE_QUESTIONS_WORKFLOWS = 'intake_questions_workflows',
	WORKFLOWS = 'workflows',
	CALL_WORKFLOWS = 'callWorkflows',
}

// Type for agent workflow fields
export type AgentWorkflowFieldType = string | string[] | any[] | undefined;

// Type for parsed workflows object
export type ParsedWorkflows = {
	[WORKFLOW_TYPES.INTAKE]: any[];
	[WORKFLOW_TYPES.SMS]: any[];
	[WORKFLOW_TYPES.TRANSFER]: any[];
};

// Workflow Configuration
export const WORKFLOW_CONFIG = {
	[WORKFLOW_TYPES.INTAKE]: {
		title: 'Intake Forms',
		description: 'Collect customer information during calls',
		color: 'blue',
		agentField: AGENT_WORKFLOW_FIELDS.INTAKE_QUESTIONS_WORKFLOWS,
		addButtonText: 'Add Intake Form',
	},
	[WORKFLOW_TYPES.SMS]: {
		title: 'SMS Follow-ups',
		description: 'Send automated text messages and responses',
		color: 'green',
		agentField: AGENT_WORKFLOW_FIELDS.WORKFLOWS,
		addButtonText: 'Add SMS Follow-up',
	},
	[WORKFLOW_TYPES.TRANSFER]: {
		title: 'Call Transfers',
		description: 'Transfer calls to team members',
		color: 'purple',
		agentField: AGENT_WORKFLOW_FIELDS.CALL_WORKFLOWS,
		addButtonText: 'Add Call Transfer',
	},
} as const;

// Tailwind Color Classes
export const WORKFLOW_COLORS = {
	blue: {
		bg50: 'bg-blue-50',
		bg100: 'bg-blue-100',
		border300: 'border-blue-300',
		text600: 'text-blue-600',
	},
	green: {
		bg50: 'bg-green-50',
		bg100: 'bg-green-100',
		border300: 'border-green-300',
		text600: 'text-green-600',
	},
	purple: {
		bg50: 'bg-purple-50',
		bg100: 'bg-purple-100',
		border300: 'border-purple-300',
		text600: 'text-purple-600',
	},
} as const;

// UI Text Constants
export const UI_TEXT = {
	TITLE: 'Configure Workflows',
	SUBTITLE:
		'Select existing workflows from your agent or add new outbound-specific ones. These will run during your outbound task.',
	WORKFLOWS_SELECTED: 'workflows selected',
	QUESTIONS: 'questions',
	AVAILABLE: 'available',
	NEED_CUSTOM_TITLE: 'Need custom outbound workflows?',
	NEED_CUSTOM_DESC: 'Create task-specific workflows that will only run during outbound task.',
	NO_AGENT_SELECTED: 'Please select an agent first',
} as const;

// Default Active Keys for Collapse
export const DEFAULT_ACTIVE_KEYS: string[] = [];
